export default "__VITE_ASSET__DIjZC9Q___"